import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DynamicCssService } from '../../services/dynamic-css.service';

@Component({
  selector: 'app-login-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss']
})
export class LoginLayoutComponent implements OnInit {
  constructor(private dynamicCss: DynamicCssService) {}

  ngOnInit() {
    document.body.style.opacity = '0';
    this.dynamicCss.loadStylesheetLink('admin.css', 'admin-css').then(() => {
      document.body.style.opacity = '1';
    });
  }
}
